import { render } from "./redis.vue?vue&type=template&id=41e68a74"
import script from "./redis.vue?vue&type=script&lang=js"
export * from "./redis.vue?vue&type=script&lang=js"

import "./redis.vue?vue&type=style&index=0&id=41e68a74&lang=css"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__